var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#475EFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.2C9.5 12.8686 9.77982 12.6 10.125 12.6H13.875C14.2202 12.6 14.5 12.8686 14.5 13.2C14.5 13.5314 14.2202 13.8 13.875 13.8H10.125C9.77982 13.8 9.5 13.5314 9.5 13.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.5C9.77982 10.5 9.5 10.7686 9.5 11.1C9.5 11.4314 9.77982 11.7 10.125 11.7H13.875C14.2202 11.7 14.5 11.4314 14.5 11.1C14.5 10.7686 14.2202 10.5 13.875 10.5H10.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.3C9.5 14.9686 9.77982 14.7 10.125 14.7H13.875C14.2202 14.7 14.5 14.9686 14.5 15.3C14.5 15.6314 14.2202 15.9 13.875 15.9H10.125C9.77982 15.9 9.5 15.6314 9.5 15.3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 6C10.0596 6 9.5 6.53726 9.5 7.2L8.875 7.2C7.83947 7.2 7 8.00589 7 9V16.2C7 17.1941 7.83947 18 8.875 18H15.125C16.1605 18 17 17.1941 17 16.2V9C17 8.00589 16.1605 7.2 15.125 7.2H14.5C14.5 6.53726 13.9404 6 13.25 6H10.75ZM13.25 7.2H10.75V8.4H13.25V7.2ZM9.5 8.4H8.875C8.52982 8.4 8.25 8.66863 8.25 9V16.2C8.25 16.5314 8.52982 16.8 8.875 16.8H15.125C15.4702 16.8 15.75 16.5314 15.75 16.2V9C15.75 8.66863 15.4702 8.4 15.125 8.4H14.5C14.5 9.06274 13.9404 9.6 13.25 9.6H10.75C10.0596 9.6 9.5 9.06274 9.5 8.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignTime);
export default __webpack_public_path__ + "static/media/campaign-time.ae22847ae3507c53759644dd7010360d.svg";
export { ForwardRef as ReactComponent };